import React from "react";
import { GiftIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/bonuses";
export function BonusesSection() {
  return <section className="bg-navy px-4 py-16 sm:py-24" data-id="element-109" data-mp="qek361dkp35b">
      <div className="mx-auto max-w-5xl" data-id="element-110" data-mp="vbaiunlgtwq7">
        <div className="mx-auto mb-4 flex w-fit items-center gap-2 rounded-full bg-gold px-4 py-2 text-sm font-black uppercase text-ink" data-id="element-111" data-mp="vc2etziz5wh0">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-112" data-mp="1o080cohurphw" />
          Included free
        </div>
        <SectionHeading title={<>
              <span className="text-gold" data-id="element-114" data-mp="19bbjc1xtj255">5 Exclusive Bonuses</span> — more than the six blueprints
            </>} intro="Five additional resources to help you organize clinical reviews, communicate concerns, and document treatment progress." data-id="element-113" data-mp="19bldm1pwbvgn" />

        <div className="mt-12 space-y-16 sm:space-y-20" data-id="element-115" data-mp="26s0s6fl6r4o1">
          {bonuses.map(b => <article key={b.label} className="grid items-center gap-6 lg:grid-cols-2 lg:gap-12" data-id="element-116" data-mp="2m4picdhlr665">
              <div className="-mx-4 sm:mx-0" data-id="element-117" data-mp="2h776ae8agatx">
                <img src={b.image} alt={`${b.title} mockup`} className="w-full sm:rounded-3xl" loading="lazy" data-id="element-118" data-mp="2h4b76mkpfg3w" />
              </div>
              <div data-id="element-119" data-mp="2r4vb5wzlyypt">
                <div className="flex flex-wrap items-center gap-3" data-id="element-120" data-mp="2r4bvyo1ceofh">
                  <span className="rounded-lg bg-gold px-3 py-1 text-sm font-black uppercase text-ink" data-id="element-121" data-mp="34w06wnzuv6uv">{b.label}</span>
                  <span className="text-base font-bold text-white/60" data-id="element-122" data-mp="2zxf5il8vah4u">
                    Value: <span className="line-through" data-id="element-123" data-mp="3eu67n29xe6y5">${b.value}</span>
                  </span>
                  <span className="rounded-lg bg-cta px-3 py-1 text-sm font-black uppercase text-ink" data-id="element-124" data-mp="39v3as543n719">Free today</span>
                </div>
                <h3 className="mt-4 font-display text-[26px] font-extrabold leading-tight text-white sm:text-3xl" data-id="element-125" data-mp="1kh6jgkrhc4f9">{b.title}</h3>
                <p className="mt-2 text-lg font-bold text-brand" data-id="element-126" data-mp="1fiwmc4m72tr0">{b.headline}</p>
                <p className="mt-3 text-base leading-relaxed text-white/75" data-id="element-127" data-mp="256iugfcb7450">{b.description}</p>
                <ul className="mt-5 space-y-2.5" data-id="element-128" data-mp="297uf06gbsz6c">
                  {b.items.map(item => <li key={item} className="flex gap-2.5 text-base leading-snug text-white/90" data-id="element-129" data-mp="2e4uge428ddr4">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-130" data-mp="2j60ao6bjh92r" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm italic leading-relaxed text-white/50" data-id="element-131" data-mp="2s4cbf164dn8x">{b.note}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-14" data-id="element-132" data-mp="31v6yg7r6wqvf">
          <CTAButton label="Yes, include all 5 bonuses" sublabel="$167 in bonuses — free with your order" data-id="element-133" data-mp="31uf5l4oz978u" />
        </div>
      </div>
    </section>;
}